import React from 'react';

const HeroContent = () => {
  return (
    <div className="hero-content-wrapper">
      <div className="hero-text-box">
        <h1 className="hero-main-title">
          <span className="title-thin">NAJMODERNIJI</span>
          <span className="title-thin">NAČIN DA</span>
          <span className="title-bold">OPEREŠ SVOJ <span className="text-accent">AUTO</span></span>
        </h1>
        <p className="hero-subtext">
          Zaboravi na žetone i sitan novac. Preuzmi potpunu kontrolu uz prvu 
          digitalnu pretplatu za pranje vozila u Srbiji. 
        </p>
      </div>
    </div>
  );
};

export default HeroContent;